import React, { useEffect, useState } from "react";
import MovieCard from "../../commom/movie-card";
import { videoRepo } from "@/repo/video-repo";
import { Movie } from "@/entry/server/movie";
import "@/styles/movies-row.css";

export default function RelatedMovies({ id }: { id: number }) {
    const [relatedMovies, setRelatedMovies] = useState<Movie[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(function () {
        getRelatedMovies();
    }, [id]);

    function getRelatedMovies() {
        videoRepo.getRelatedMovies(id).then(function (response) {
            if (response.status) {
                setRelatedMovies(response.data ? response.data : []);
            }
            setLoading(false);
        }).catch(function () {
            setLoading(false);
        });
    }

    return (
        <>
            <h2 className="movie-detail-section-title">فیلم های پیشنهادی</h2>
            {loading && (
                <div className="related-movies__loading shimmer" />
            )}
            {relatedMovies.length > 0 && (
                <div className="movies-row">
                    {relatedMovies.map(function (movie) {
                        return (
                            <MovieCard
                                key={movie.id}
                                id={movie.id}
                                slug={movie.slug}
                                type={movie.type}
                                title={movie.title}
                                updateText={movie.update_text}
                                year={movie.year != null ? String(movie.year) : ""}
                                ratingValue={movie.imdb_rate != null ? String(movie.imdb_rate) : "0"}
                                thumbnail={movie.thumbnail}
                                isDubbed={movie.is_dubbed}
                                isSubtitled={movie.is_subbed}
                                genres={movie.genres ? movie.genres : []}
                            />
                        );
                    })}
                </div>
            )}
        </>
    );
}
